import { colors } from '@lmc/common/constants'
import { Button } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import React from 'react'

const Tag = ({ label }) => <span style={styles.tag}>{label}</span>

const Line = ({ margin }) => <hr style={{ margin: margin || '8px 0' }} />

const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
  if (newWindow) newWindow.opener = null
}

const Section = ({ label, text }) => {
  if (!label && !text) return null
  return (
    <div>
      {label ? <div style={styles.subLabel}>{label}</div> : null}
      {text ? <div style={styles.descriptionText}>{text}</div> : null}
      <Line />
    </div>
  )
}

const MemberBenefit = ({ benefit }) => {
  const {
    title,
    subTitle,
    description,
    subTitleSecondary,
    descriptionSecondary,
    buttonText,
    buttonUrl,
    readMoreUrl,
    tags,
    imageUrl,
    isFeatured
  } = benefit

  const containerStyle = {
    ...styles.container,
    border: isFeatured ? `1px solid ${colors.primary}` : null
  }

  return (
    <div className="lmc-card" style={containerStyle}>
      <div style={styles.imgContainer}>
        <img style={styles.img} src={imageUrl} alt="" />
        {readMoreUrl && (
          <div style={styles.readMore}>
            <a href={readMoreUrl} target="_blank" rel="noreferrer">
              Read More
            </a>
          </div>
        )}
      </div>
      <div style={styles.bodyContainer}>
        <div style={styles.titleContainer}>
          <div style={styles.title}>{title}</div>
          <div>{tags && tags.map((tag) => <Tag label={tag} />)}</div>
        </div>
        <div style={styles.lineHeight}>
          <Section label={subTitle} text={description} />
          <Section label={subTitleSecondary} text={descriptionSecondary} />
          <div style={styles.subLabel}>Get Deal</div>
          <Button onClick={() => openInNewTab(buttonUrl)} variant="primary">
            {buttonText}
          </Button>
          <Line margin="8px 0 2px" />
        </div>
      </div>
    </div>
  )
}

MemberBenefit.propTypes = {
  benefit: PropTypes.object.isRequired
}

const styles = {
  container: {
    display: 'flex',
    marginBottom: 16
  },
  imgContainer: {
    width: 120
  },
  img: {
    width: 96
  },
  readMore: {
    textAlign: 'center',
    paddingTop: 8
  },
  tag: {
    background: colors.grey,
    padding: '3px 8px',
    fontSize: 12,
    marginLeft: 4
  },
  bodyContainer: {
    marginLeft: 16,
    color: colors.black
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 14
  },
  title: {
    fontWeight: 'bold',
    fontSize: 16
  },
  lineHeight: {
    lineHeight: '22px'
  },
  subLabel: {
    fontSize: 12,
    fontWeight: 'bold'
  },
  descriptionText: {
    fontSize: 14
  }
}

export default MemberBenefit
